<p>loading-dialog works!</p>
